import { isAxiosError } from 'axios';

import { axios } from 'data';
import { HttpStatus, Nullish } from 'types/common';
import { UploadFileLike } from 'types/components';
import { FileType, UploadedFile } from 'types/models';
import { FileParams, FileUploadParams } from 'types/services';

const getFile = async (type: FileType): Promise<Nullish<UploadedFile>> => {
  try {
    const params: FileParams = { fileType: type };
    const response = await axios.head('/client/file', { params });
    const name = axios.getResponseFileName(response) ?? type;

    return { type, name };
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === HttpStatus.NOT_FOUND) {
      return;
    }

    throw error;
  }
};

const downloadFile = async (type: FileType) => {
  const params: FileParams = { fileType: type };
  const response = await axios.get<Blob>('/client/file', { params, responseType: 'blob' });

  return response.data;
};

const uploadFile = async (type: FileType, file: UploadFileLike) => {
  const params: FileUploadParams = { fileType: type, file };

  await axios.postForm<never>('/client/file', params);
};

const fileService = {
  getFile,
  downloadFile,
  uploadFile,
};

export default fileService;
